import ApprentiDateFin from '@/generated/controls/apprenti/ApprentiDateFin.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: ApprentiDateFin
})
